import CultureSelector from '@skyscanner-internal/global-components/culture-selector/CultureSelector';
import { getSessionHandoffToken } from '@skyscanner-internal/global-components/culture-selector/helpers';
import { getGcCultureSelectorData } from '@web-platform/shared-universal-utils-frontend/src/singletons/cultureSelectorData';
import { getCulture } from '@web-platform/shared-universal-utils-frontend-localisation';
import { logError, logOperationalEvent, logWarn } from 'saddlebag-logger';

import type {
  CultureSelectorCurrency,
  CultureSelectorLocale,
  CultureSelectorMarket,
} from '@skyscanner-internal/global-components/culture-selector/CultureSelector';

type OwnProps = {
  isOpen: boolean;
  onClose: () => void;
  currencies: CultureSelectorCurrency[];
  markets: CultureSelectorMarket[];
  enMarkets: CultureSelectorMarket[];
  locales: CultureSelectorLocale[];
  persistUserSessionDataFn: () => Promise<string | null>;
};

const CultureSelectorModal = (props: OwnProps) => {
  const { currencies, enMarkets, isOpen, locales, markets, onClose, persistUserSessionDataFn } =
    props;
  const { enStrings, strings } = getGcCultureSelectorData();

  const { currency, locale, market } = getCulture();

  return (
    <CultureSelector
      isOpen={isOpen}
      onClose={onClose}
      currency={currency}
      locale={locale}
      market={market}
      strings={strings}
      enStrings={enStrings}
      markets={markets}
      locales={locales}
      currencies={currencies}
      enMarkets={enMarkets}
      isProductionEnv
      logger={{
        logError,
        logWarn,
        logOperationalEvent,
      }}
      persistUserSessionDataFn={persistUserSessionDataFn}
      getSessionHandoffTokenFn={getSessionHandoffToken}
    />
  );
};

export default CultureSelectorModal;
